import { ui, defaultLang, languages, paths } from "./ui";

export function getLocaleFromUrl(url: URL): "de" | "en" | "fr" | "it" {
    const [, lang] = url.pathname.split("/");
    if (lang in languages) return languages[lang];
    return "de";
}

export function getPathFromLocale(locale: string, _paths = paths) {
    if (locale in _paths) return _paths[locale];
    return "";
}

export function getLocalizedPath(
    path: string | undefined,
    locale: string,
    leadingSlash = true,
) {
    if (!path) return "";

    // remove leading slash
    path = path.replace(/^\//, "");

    const localePath = getPathFromLocale(locale);

    let prefix = "";

    if (leadingSlash && localePath) {
        prefix = `/${localePath}/`;
    } else if (localePath && !leadingSlash) {
        prefix = `${localePath}/`;
    } else if (leadingSlash && !localePath) {
        prefix = "/";
    } else {
        prefix = "";
    }

    return `${prefix}${path}`;
}

export function getUnLocalizedPath(
    path: string | undefined,
    localePath: string,
) {
    if (!path) return "";
    path = path.replace(/^\//, "");
    return path.replace(new RegExp(`^${localePath}\/`), "");
}

export function useTranslations(lang: keyof typeof ui) {
    return function t(
        key: keyof (typeof ui)[typeof defaultLang],
        variables?: Record<string, string>,
    ) {
        if (!lang) throw new Error(`No language provided while translating "${key}"`);
        const translation = ui[lang][key] || ui[defaultLang][key] || key;
        if (!variables) return translation;
        return translation.replace(
            /{([^{}]*)}/g,
            (a, b) => variables[b] || `{${b}}`,
        );
    };
}
